// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__2CfTn","loaderOuter":"PageOverlayLoader_loaderOuter__3XxHP"};